import React, { useMemo } from "react";
import ScoreGauge from "../Report/ScoreGauge";
import { prepareMarkdownForBlocks } from "./dualLensMarkdownDiff";
import {
	computeContentVisibilityPct,
	computeMissingWords,
	getVisibilitySublabel,
} from "./dualLensScore";

function getMarkdown(content, key) {
	return content?.markdown?.[key]?.trim() ?? "";
}

function getHostname(url) {
	if (!url) return "";
	try {
		return new URL(url).hostname.replace(/^www\./, "");
	} catch {
		return url;
	}
}

export default function DualLensScoreCard({ url, status, content }) {
	const aiMd = useMemo(
		() => prepareMarkdownForBlocks(getMarkdown(content, "playwright_no_js")),
		[content]
	);
	const humanIdleMd = useMemo(
		() => prepareMarkdownForBlocks(getMarkdown(content, "playwright_idle")),
		[content]
	);

	const missingWords = useMemo(
		() => computeMissingWords(aiMd, humanIdleMd),
		[aiMd, humanIdleMd]
	);
	const visibilityPct = useMemo(
		() => computeContentVisibilityPct(aiMd, humanIdleMd),
		[aiMd, humanIdleMd]
	);
	const sublabel = useMemo(() => getVisibilitySublabel(visibilityPct), [visibilityPct]);

	const hostname = getHostname(url);
	const isActive = String(status || "").toLowerCase() === "completed";

	return (
		<section className="dual-lens__score-card" aria-label="AI Content Visibility">
			<div className="dual-lens__score-card-header">
				<h2 className="dual-lens__score-card-title mb-0">AI Content Visibility</h2>
				<p className="dual-lens__score-card-subtitle text-muted mb-0">
					How much of what visitors see is also available to AI crawlers without
					JavaScript.
				</p>
			</div>

			{hostname && (
				<div className="dual-lens__score-card-domain">
					<span className="dual-lens__score-card-domain-name">
						<i className="fas fa-globe me-2" aria-hidden="true" />
						{hostname}
					</span>
					{isActive && (
						<span className="dual-lens__score-card-domain-badge">
							<i className="fas fa-check-circle me-1" aria-hidden="true" />
							Active
						</span>
					)}
				</div>
			)}

			<div className="dual-lens__score-card-gauge">
				<ScoreGauge
					value={visibilityPct}
					label="Content Visibility"
					sublabel={sublabel}
				/>
			</div>

			<div className="dual-lens__score-card-missing">
				<p className="dual-lens__score-card-missing-value mb-0">{missingWords}</p>
				<p className="dual-lens__score-card-missing-label mb-0">MISSING WORDS</p>
			</div>
		</section>
	);
}
